/* Paneles del footer (verbatim web/_partials/footer.html) + guía de tallas interactiva (verbatim scripts-tail-b) */
(function(){
var wrap = document.querySelector('.hn-footer-wrap');
if(!wrap) return;
var panel = document.getElementById('hn-footer-panel');
var panelOverlay = document.getElementById('hn-footer-panel-overlay');
var panelEyebrow = document.getElementById('hn-footer-panel-eyebrow');
var panelTitle = document.getElementById('hn-footer-panel-title');
var panelDesc = document.getElementById('hn-footer-panel-desc');
var panelClose = document.getElementById('hn-footer-panel-close');
var panelInner = panel.querySelector('.hn-footer-panel-inner');
var FINAL_W = Math.min(520, window.innerWidth - 48);
var panelOpener = null;

function finalRect(wrapRect, targetH, panelW){
var vh = window.innerHeight;
var margin = 24;
var top = (vh / 2) - (targetH / 2) - wrapRect.top;
var minTop = margin - wrapRect.top;
var maxTop = (vh - margin) - targetH - wrapRect.top;
if(maxTop < minTop) maxTop = minTop;
if(top < minTop) top = minTop;
if(top > maxTop) top = maxTop;
var left = (wrapRect.width / 2) - (panelW / 2);
var minLeft = 8, maxLeft = wrapRect.width - panelW - 8;
if(left < minLeft) left = minLeft;
if(left > maxLeft) left = maxLeft;
return {top: top, left: left};
}

function openFooterPanel(node){
panelOpener = node;
window.henuaLockScroll();
panelEyebrow.textContent = node.dataset.eyebrow || '';
panelTitle.textContent = node.dataset.title || '';
var contentId = node.dataset.contentId;
var tpl = contentId ? document.getElementById(contentId) : null;
if(tpl){
panelDesc.classList.add('is-rich');
panelDesc.innerHTML = '';
panelDesc.appendChild(tpl.content.cloneNode(true));
var isHistoryReveal = !!panelDesc.querySelector('.hs-history-reveal-content');
panelInner.classList.toggle('has-history-reveal', isHistoryReveal);
panel.classList.toggle('history-reveal-open', isHistoryReveal);
makePinsKeyboardReachable(panelDesc);
} else {
panelDesc.classList.remove('is-rich');
panelInner.classList.remove('has-history-reveal');
panel.classList.remove('history-reveal-open');
panelDesc.textContent = node.dataset.desc || '';
}

var panelW = tpl ? Math.min(980, window.innerWidth - 48) : FINAL_W;
var wrapRect = wrap.getBoundingClientRect();
var startRect = node.getBoundingClientRect();

panel.style.transition = 'none';
panel.style.width = panelW + 'px';
panel.style.height = 'auto';
panel.style.top = '-9999px';
panel.style.left = '-9999px';
panel.style.borderRadius = '18px';
panel.classList.add('on');
var targetH = panel.offsetHeight;
var target = finalRect(wrapRect, targetH, panelW);

panel.style.top = (startRect.top - wrapRect.top) + 'px';
panel.style.left = (startRect.left - wrapRect.left) + 'px';
panel.style.width = startRect.width + 'px';
panel.style.height = startRect.height + 'px';
panel.style.borderRadius = '22px';

panel.setAttribute('aria-hidden','false');
panelOverlay.classList.add('on');
panelClose.focus({ preventScroll: true });

void panel.offsetHeight;
var henuaReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
requestAnimationFrame(function(){
panel.style.transition = henuaReduceMotion ? 'none' : 'top .38s cubic-bezier(.16,1,.3,1),left .38s cubic-bezier(.16,1,.3,1),width .38s cubic-bezier(.16,1,.3,1),height .38s cubic-bezier(.16,1,.3,1),border-radius .38s cubic-bezier(.16,1,.3,1),opacity .2s ease';
panel.style.top = target.top + 'px';
panel.style.left = target.left + 'px';
panel.style.width = panelW + 'px';
panel.style.height = targetH + 'px';
panel.style.borderRadius = '18px';
});
}
function closeFooterPanel(){
if(!panel.classList.contains('on')) return;
panel.classList.remove('on');
panel.setAttribute('aria-hidden','true');
panelOverlay.classList.remove('on');
window.henuaUnlockScroll();
if(panelOpener && document.contains(panelOpener) && panelOpener.focus){ panelOpener.focus(); }
panelOpener = null;
}
/* Los puntos y números de la guía de tallas eran solo para ratón: ahora se alcanzan con teclado (WCAG 2.1.1, 4.1.2) */
function makePinsKeyboardReachable(scope){
scope.querySelectorAll('.hn-size-pin').forEach(function(pin){
var tip = pin.querySelector('.hn-size-pin-tip');
pin.setAttribute('tabindex','0');
pin.setAttribute('role','button');
pin.setAttribute('aria-pressed','false');
if(tip) pin.setAttribute('aria-label', tip.textContent.replace(/\s+/g,' ').trim());
});
scope.querySelectorAll('.hn-size-step-num').forEach(function(n){
n.setAttribute('tabindex','0');
n.setAttribute('role','button');
});
}
panel.addEventListener('keydown', function(e){ window.henuaTrapTab(e, panel); });
panel.addEventListener('focusin', function(e){
var card = e.target.closest ? e.target.closest('.hs-history-reveal-product') : null;
if(!card) return;
var row = card.closest('.hs-history-reveal-product-grid');
if(!row) return;
var rowRect = row.getBoundingClientRect();
var cardRect = card.getBoundingClientRect();
var safeLeft = rowRect.left + 8;
var safeRight = rowRect.right - 8;
var delta = cardRect.left < safeLeft ? cardRect.left - safeLeft : (cardRect.right > safeRight ? cardRect.right - safeRight : 0);
if(!delta) return;
var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
row.scrollBy({left: delta, behavior: reduceMotion ? 'auto' : 'smooth'});
});
panel.addEventListener('keydown', function(e){
if(e.key !== 'Enter' && e.key !== ' ') return;
var t = e.target.closest ? e.target.closest('.hn-size-pin, .hn-size-step-num') : null;
if(!t) return;
e.preventDefault();
t.click();
if(t.classList.contains('hn-size-pin')) t.setAttribute('aria-pressed', String(t.classList.contains('is-active')));
});
panelClose.addEventListener('click', closeFooterPanel);
panelOverlay.addEventListener('click', closeFooterPanel);
document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeFooterPanel(); });

document.addEventListener('click', function(e){
var link = e.target.closest ? e.target.closest('.hn-footer-link') : null;
if(!link) return;
e.preventDefault();
openFooterPanel(link);
});

document.addEventListener('click', function(e){
var pin = e.target.closest ? e.target.closest('.hn-size-pin') : null;
if(pin){
var wasActive = pin.classList.contains('is-active');
document.querySelectorAll('.hn-size-pin.is-active').forEach(function(p){ p.classList.remove('is-active'); });
if(!wasActive) pin.classList.add('is-active');
return;
}
if(!e.target.closest || !e.target.closest('.hn-size-top-grid, .hn-size-diagram')){
document.querySelectorAll('.hn-size-pin.is-active').forEach(function(p){ p.classList.remove('is-active'); });
}
});
})();
(function(){
var linkSvg = document.createElementNS('http://www.w3.org/2000/svg','svg');
linkSvg.setAttribute('id','hn-size-linkline-svg');
linkSvg.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:150;';
document.body.appendChild(linkSvg);
var scrollTicking = false;
function clearSizeGuideHighlights(){
scrollTicking = false;
if(!linkSvg.firstChild && !document.querySelector('.hn-size-step.is-open, .hn-size-pin.is-active')) return;
linkSvg.innerHTML = '';
document.querySelectorAll('.hn-size-step.is-open').forEach(function(s){ s.classList.remove('is-open'); });
document.querySelectorAll('.hn-size-pin.is-active').forEach(function(p){ p.classList.remove('is-active'); });
}
/* Throttle con rAF: como máximo una limpieza por cuadro, sin bloquear el scroll (pasivo) */
document.addEventListener('scroll', function(){
if(scrollTicking) return;
scrollTicking = true;
requestAnimationFrame(clearSizeGuideHighlights);
}, { capture: true, passive: true });

function henuaPulseZone(zone, panelScope, showLine){
var pinWrap = panelScope.querySelector('.hn-size-pin[data-zone="' + zone + '"]');
var pin = pinWrap ? pinWrap.querySelector('.hn-size-pin-visdot') : null;
var stepNum = panelScope.querySelector('.hn-size-step-num[data-zone="' + zone + '"]');
[pin, stepNum].forEach(function(el){
if(!el) return;
el.classList.remove('hn-size-pulse');
void el.offsetWidth;
el.classList.add('hn-size-pulse');
});
if(pin && stepNum && showLine){
linkSvg.innerHTML = '';
var pr = pin.getBoundingClientRect();
var sr = stepNum.getBoundingClientRect();
var x1 = pr.left + pr.width/2, y1 = pr.top + pr.height/2;
var x2 = sr.left + sr.width/2, y2 = sr.top + sr.height/2;
var mx = (x1 + x2) / 2;
var curveOffset = (y2 - y1) * 0.35;
var line = document.createElementNS('http://www.w3.org/2000/svg','path');
line.setAttribute('d', 'M ' + x1 + ' ' + y1 + ' Q ' + mx + ' ' + (y1 + curveOffset) + ' ' + x2 + ' ' + y2);
line.setAttribute('fill', 'none');
line.setAttribute('stroke', '#B5563A');
line.setAttribute('stroke-width', '2');
line.setAttribute('stroke-linecap', 'round');
line.style.opacity = '1';
linkSvg.appendChild(line);
var len = line.getTotalLength();
line.style.strokeDasharray = len;
line.style.strokeDashoffset = len;
line.style.transition = 'none';
void line.getBoundingClientRect();
line.style.transition = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'none' : 'stroke-dashoffset .55s cubic-bezier(.4,0,.2,1)';
requestAnimationFrame(function(){ line.style.strokeDashoffset = '0'; });
}
}
document.addEventListener('click', function(e){
if(e.target.closest && (e.target.closest('.hn-footer-panel-close') || e.target.id === 'hn-footer-panel-overlay')){
linkSvg.innerHTML = '';
}
});
document.addEventListener('mouseenter', function(e){
var el = e.target;
if(!el.classList) return;
if(el.classList.contains('hn-size-step-num') || el.classList.contains('hn-size-pin')){
var zone = el.dataset.zone;
var scope = el.closest('.hn-footer-panel-body');
if(zone && scope) henuaPulseZone(zone, scope, false);
}
}, true);
document.addEventListener('click', function(e){
var target = e.target.closest ? e.target.closest('.hn-size-step-num, .hn-size-pin') : null;
if(!target) return;
var zone = target.dataset.zone;
var scope = target.closest('.hn-footer-panel-body');
var layoutShifting = false;
var isNewlyOpened = false;
if(zone && scope){
var stepsCol = scope.querySelector('.hn-size-steps');
if(stepsCol){
var targetStep = stepsCol.querySelector('.hn-size-step[data-zone="' + zone + '"]') || (function(){
var num = stepsCol.querySelector('.hn-size-step-num[data-zone="' + zone + '"]');
return num ? num.closest('.hn-size-step') : null;
})();
var wasOpen = targetStep && targetStep.classList.contains('is-open');
var anyOtherOpen = Array.prototype.some.call(stepsCol.querySelectorAll('.hn-size-step.is-open'), function(s){ return s !== targetStep; });
if(anyOtherOpen || (targetStep && !wasOpen)) layoutShifting = true;
isNewlyOpened = !!(targetStep && !wasOpen);
stepsCol.querySelectorAll('.hn-size-step.is-open').forEach(function(s){ s.classList.remove('is-open'); });
if(targetStep && !wasOpen) targetStep.classList.add('is-open');
}
}
henuaPulseZone(zone, scope, false);
if(isNewlyOpened){
setTimeout(function(){ henuaPulseZone(zone, scope, true); }, layoutShifting ? 380 : 0);
} else {
linkSvg.innerHTML = '';
}
});
})();
